import { useCollection, useDatastore, usePersonaKey } from "util/datastore";
import { PollSurveyThenResults } from "component/poll";
import { Feature, nullS, Table, undefS, undefSL, undefTL, TLabel, t, undefTLS } from "util/stdtypes";

export type PollVote = {
    key: string;
    from: string;
    value: { label: TLabel | null; comment?: string | null };
};

export type PollFeatureProvidedConfig = {
    PollWidget: React.ComponentType<PollWidgetProps>;
};

export const PollFeature: Feature<PollFeatureProvidedConfig, { visualizationType: string }> = {
    name: 'Poll',
    key: 'poll',
    providesConfig: {
        PollWidget: PollWidget,
    },
    receivesConfigDefaults: {
        visualizationType: 'percent'
    }
}

export type PollWidgetProps = {
    pollKey: Table<PollVote>;
    question: string;
    optionLabels?: TLabel[];
    optionTexts?: string[];
    showOtherOption?: boolean;
    otherOptionLabel?: TLabel;
    otherOptionText?: string;
    otherOptionPlaceholder?: TLabel;
};

export function PollWidget({
    pollKey,
    question,
    optionLabels=undefTLS,
    optionTexts=undefSL,
    showOtherOption=false,
    otherOptionLabel = undefTL,
    otherOptionText=undefS,
    otherOptionPlaceholder=undefTL,
}: PollWidgetProps) {

    const datastore = useDatastore();
    const personaKey = usePersonaKey();
    const voteObjects = useCollection(pollKey);

    const votes = voteObjects.map(vote => vote?.value?.label ?? undefined);
    const myVoteObject = voteObjects.find(v => v?.from == personaKey);

    const myVote = myVoteObject?.value?.label ?? undefined;
    const myComment = myVoteObject?.value?.comment ?? null;

    const onVote = (vote: string | null, comment: string | null = null) => {
        const existing = datastore.getCollection(pollKey, { filter: { from: personaKey } });
        existing.forEach((r) => datastore.deleteObject(pollKey, r.key));
        const value: { label: TLabel | null; comment?: string | null } = { label: vote ? t(vote) : null };
        if (comment) value.comment = comment;
        datastore.addObject(pollKey, { value });
    }

    return <PollSurveyThenResults
        question={question}
        optionLabels={optionLabels}
        optionTexts={optionTexts}
        onVote={datastore.needsLogin(onVote, 'vote')}
        votes={votes}
        myVote={myVote}
        myComment={myComment}
        showOtherOption={showOtherOption}
        otherOptionLabel={otherOptionLabel}
        otherOptionText={otherOptionText}
        otherOptionPlaceholder={otherOptionPlaceholder}
    />
}
